import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CoordinationsAlerts} from "../../services/coordinations-alerts.service";
import {CoordinationsDialogService} from "../../services/coordinations-dialog-service.service";
import {CoordinationRequests} from "../../services/coordinations-requests.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class servicesTableCtrl implements IController {

  services: any;
  coordination: any;
  queryString: string;
  selectedServiceIds: any;
  selectAllServicesMode: any;
  onSelectAllServices: Function;
  updateService: Function;

  /* @ngInject */
  constructor(private coordinationsDialogService: CoordinationsDialogService, private $log, private confirmDialogService: ConfirmDialogService,
              private deliveriesAlertsService: DeliveriesAlertsService, private coordinationsAlerts: CoordinationsAlerts, private coordinationRequests: CoordinationRequests) {
  }

  ////////////////////////////////////////////////////////////////////////////////

  // ******************************
  //        External methods
  // ******************************

  onOpenActionMenu(service, callback) {
    const serviceCoordinationStatus = service.coordinationStatus,
      disableCondition = _.isEqual(serviceCoordinationStatus, 'ServiceCreated') ||
        _.isEqual(serviceCoordinationStatus, 'DeclinedByAdmin') ||
        _.isEqual(serviceCoordinationStatus, 'DeclinedByUser');
    callback({
      editService: disableCondition,
      sendSms: disableCondition,
      decline: disableCondition,
      createDeliveries: !_.isEqual(serviceCoordinationStatus, 'ValidatedByUser') &&
        !_.isEqual(serviceCoordinationStatus, 'ValidatedByAdmin')
    })
  }

  onSendServiceTextMessage(event, serviceToAction) {
    const title = 'Send SMS - Service #' + serviceToAction.id,
      textContent = 'Are you sure you want to send service SMS?';
    this.confirmDialogService.confirm(title, textContent, event)
      .then(() => {
        return this.coordinationRequests.sendServicesTextMessage(serviceToAction.id)
      })
      .then((updatedService) => {
        this.coordinationsAlerts.sendSMSToServicesSuccess();
        this.updateService({updatedService: updatedService});
      })
      .catch((error) => {
        this.coordinationsAlerts.sendSMSToServicesError();
        this.$log.error('Failed to send SMS to service, ' +
          'servicesTable@sendServiceTextMessage \n' + error);
      })

      .finally(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreateDelivery(event, serviceToAction) {
    if (!_.isEqual(serviceToAction.coordinationStatus, 'Idle')) {
      this.coordinationsDialogService.createDeliveries(event, this.coordination, serviceToAction.id)
        .then((updatedService) => {
          if (updatedService) {
            this.deliveriesAlertsService.createDeliverySuccess();
            this.updateService({updatedService: updatedService});
          }
        })
        .catch((error) => {
          if (error) {
            this.deliveriesAlertsService.createDeliveryError();
            this.$log.error('Failed to create deliveries @servicesTable@onCreateDeliveries', error);
          } else {
            this.$log.info('Closed Dialog')
          }
        })
    } else {

    }
  }

  onDeclineService(event, serviceToAction) {
    const title = serviceToAction.id,
      textContent = 'Are you sure you want to decline delivery?';
    this.confirmDialogService.confirm(title, textContent, event)
      .then(() => {
        return this.coordinationRequests.declineServices(serviceToAction.id)
      })
      .then((updatedService) => {
        this.coordinationsAlerts.declineServicesSuccess();
        this.updateService({updatedService: updatedService});
      })
      .catch((error) => {
        this.coordinationsAlerts.declineServicesError();
        this.$log.error('Failed to decline service, ' +
          'servicesTable@onDeclineService \n' + error);
      })
      .finally(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEditService(event, serviceToAction) {
    this.coordinationsDialogService.editService(event, serviceToAction)
      .then((updatedService) => {
        if (updatedService) {
          this.coordinationsAlerts.updateServiceSuccess();
          this.updateService({updatedService: updatedService});
        }
      })
      .catch((error) => {
        if (error) {
          this.coordinationsAlerts.updateServiceError();
        }
        this.$log.info('Closed Dialog')
      })
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('servicesTable', {
    bindings: {
      services: '<',
      coordination: '<',
      queryString: '<',
      selectedServiceIds: '<',
      selectAllServicesMode: '=',
      onSelectAllServices: '&',
      updateService: '&'
    },
    template: require('./services-table.tmpl.html').default,
    controller: servicesTableCtrl
  });
